import Path from 'assets/icons/base/Path';
import PropTypes from 'prop-types';
import React from 'react';
import SVG from 'assets/icons/base/SVG';
import colors from 'config/theme/colors';

const MinusIcon = ({ color = colors.black, height = '14px', width = '14px', viewBox = '0 0 16 16' }) => (
    <SVG width={width} height={height} viewBox={viewBox}>
        <Path stroke={color} d="M0 8L16 8" />
    </SVG>
);

MinusIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

export default MinusIcon;
